<template>
    <div class="page-box-container">

        <!-- Register box -->
        <!-- Register form -->
        <box class="mb-md-15 mb-xxl-30 large-page-box" :padding="60">
            <template v-slot:content>

                <i-logo-color class="i-logo mb-30 d-block d-md-none" />
                <div class="w-100 fs-20 lh-20 mb-15 fw-sb">{{$t(`${$options.name}.title`)}}</div>
                <div class="fs-15 lh-15 text-light mb-30">{{$t(`${$options.name}.description`)}}</div>
                <el-form @submit="submit" :error="server_error" :loading="loading" :success="success" :button-text="`${$options.name}.button`">
                    <el-avatar-upload class="mb-30" v-model="user.uploadedFile" />
                    <div class="form-row mb-15">
                        <el-input class="col-12 col-lg-6" v-model="user.first_name" name="firstname" rule="required" />
                        <el-input class="col-12 col-lg-6" v-model="user.last_name" name="lastname" rule="required" />
                        <el-input class="col-12" v-model="user.email" type="email" name="email" rule="required|email" />
                        <el-input class="col-12" v-model="user.password" type="password" name="password" rule="required" />
                    </div>

                    <div class="mb-0" v-if="gdprConfig">
                        <span v-if="errors.first('agr_GDPRCheck--privacy-policy') || errors.first('agr_GDPRCheck--terms-of-use')" class="small my-3 text-danger">{{ $t('general.gdpr_validation_error') }}</span>

                        <div class="custom-control custom-checkbox my-5">
                            <input v-validate="'required'" v-model="gdpr.privacy_policy" type="checkbox" class="custom-control-input" name="agr_GDPRCheck--privacy-policy" id="agr_GDPRCheck--privacy-policy">
                            <label class="custom-control-label" for="agr_GDPRCheck--privacy-policy">Ik ga akkoord met <a class="fw-b" target="_blank" :href="gdprConfig.privacy_policy">de privacyverklaring</a>.</label>
                        </div>

                        <div class="custom-control custom-checkbox my-5">
                            <input v-validate="'required'" v-model="gdpr.terms_of_use" type="checkbox" class="custom-control-input" name="agr_GDPRCheck--terms-of-use" id="agr_GDPRCheck--terms-of-use">
                            <label class="custom-control-label" for="agr_GDPRCheck--terms-of-use">Ik ga akkoord met <a class="fw-b" target="_blank" :href="gdprConfig.user_agreement">de gebruikersovereenkomst</a>.</label>
                        </div>
                    </div>

                    <template #footerLeft>
                        <router-link class="text-body-light c-pointer my-auto" :to="{ name: 'login' }">{{ $t(`${$options.name}.back_to_login`) }}</router-link>
                    </template>

                </el-form>

            </template>
        </box>

        <!-- Register subtext -->
        <!-- Navigate to login page -->
        <router-link class="text-center text-white small-box-footer d-block" :to="{ name: 'login' }">
            <i18n :path="`${$options.name}.login`">
                <span class="text-white white-hover">{{$t(`${$options.name}.login_link`)}}</span> om verder te gaan
            </i18n>
        </router-link>

    </div>
</template>

<script>
import HasForm from '@/components/forms/has-form';

export default {
    name: "views.guest.register",

    components: {
        ElForm: () => import(/* webpackChunkName: "elements" */ "@/components/forms/ElForm"),
        ElInput: () => import(/* webpackChunkName: "elements" */ "@/components/forms/ElInput"),
        ElAvatarUpload: () => import(/* webpackChunkName: "elements" */ "@/components/forms/ElAvatarUpload")
    },

    mixins: [HasForm],

    data() {
        return {
            user: {
                first_name: "",
                last_name: "",
                email: this.$route.query.email || "",
                password: "",
                uploadedFile: "",
                locale: this.$i18n.locale,
                token: this.$route.query.token || null
            },

            gdpr: {
                privacy_policy: false,
                terms_of_use: false,
            },
        };
    },
    mounted() {
        let query = this.$route.query
        let email = query.email
        let first_name = query.first_name

        if (email) this.user.email = email
        if (first_name) this.user.first_name = first_name

        this.$store.dispatch('config/getGDPRConfig')
    },
    methods: {
        submit() {
            this.$validator.validateAll().then(res => {
                if (res) {
                    this.loading = true;
                    this.$store.dispatch('auth/register', this.user).then(() => {
                        this.$store.dispatch('auth/login', this.user).then(() => {
                            this.$store.dispatch('auth/me').then(() => {
                                if (this.$route.query.workspace) {
                                    this.$router.push({ name: 'workspace', params: { id: this.$route.query.workspace } });
                                }
                                if (!this.$route.query.workspace) {
                                    this.$router.push({ name: 'workspace-create' });
                                }
                            }).catch(e => this.handleError(e));
                        }).catch(e => this.handleError(e));
                    }).catch(e => this.handleError(e));
                }
            })
        }
    },
    computed: {
        gdprConfig() {
            return this.$store.getters['config/gdpr']
        }
    }
};
</script>
